import { render } from "./uploadStatus.vue?vue&type=template&id=5af40250&scoped=true"
import script from "./uploadStatus.vue?vue&type=script&lang=js"
export * from "./uploadStatus.vue?vue&type=script&lang=js"

import "./uploadStatus.vue?vue&type=style&index=0&id=5af40250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af40250"]])

export default __exports__